import { combineReducers } from 'redux';

import * as types from 'modules/campaignFiles/actionTypes';
import { DETAILS_SOURCE } from 'modules/campaigns/constants';
import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import creationFiles from './creationFiles';
import details from './details';
import filters from './filters';

const GENERIC_SLICE_CONFIG = field => ({
  global: {
    selectId: entity => entity?.campaignFileId ?? entity?.id,
    matcher: ({ meta }) => !field || meta?.field === field,
  },
});

const campaignDetailsMatcher = ({ meta }) => meta?.source === DETAILS_SOURCE;

/**
 * @typedef {{
 *   filters: import('./filters').CampaignFileUIDetailsFiltersReducer,
 *   details: import('./details').CampaignFilesUIDetailsReducer,
 *   creationFiles: import('./creationFiles').CampaignFileCreationFilesUIReducer,
 *   campaignFiles: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *   loading: {
 *     handled: string[],
 *     patching: string[],
 *     internalMessage: string[],
 *   },
 * }} CampaignFilesUIReducer
 */

export default combineReducers({
  filters,
  details,
  creationFiles,
  campaignFiles: createSearchReducers(types.FETCH_CAMPAIGN_FILES, {
    global: { matcher: campaignDetailsMatcher, paginationSlice: true },
    ids: { [LOCATION_CHANGE]: () => [] },
  }),
  loading: combineReducers({
    patching: loadingArraySlice(types.PATCH_CAMPAIGN_FILE, GENERIC_SLICE_CONFIG()),
    approving: loadingArraySlice(types.APPROVE_MANUALLY_REQUEST, GENERIC_SLICE_CONFIG()),
    checklists: loadingArraySlice(types.CREATE_CHECKLISTS_REQUEST, GENERIC_SLICE_CONFIG()),
    handled: loadingArraySlice(types.PATCH_CAMPAIGN_FILE, GENERIC_SLICE_CONFIG('handled')),
    internalMessage: loadingArraySlice(types.PATCH_CAMPAIGN_FILE, GENERIC_SLICE_CONFIG('internalMessage')),
  }),
});
